module.exports = __webpack_public_path__ + "static/assets/2c0ecac66de6952bcf0ef6bed14a57a5.png";